import { Fragment } from "react";
import DashboardSideBar from "./DashboardSideBar";
import "../../Assets/Styles/Dashboard/Dashboard.css";
import { Outlet, useNavigate } from "react-router-dom";
import DashboardNav from "./DashboardNav";
import Loading from "../Shear/Loading/Loading";
import { useAuthState } from "react-firebase-hooks/auth";
import { useQuery } from "react-query";
import auth from "../../FirebaseInit/FirebaseInit";
import { signOut } from "firebase/auth";

const Dashboard = () => {
  let navigate = useNavigate();
  const [user, PLoading] = useAuthState(auth);
  const { data, isLoading } = useQuery(["single-user", user], () =>
    fetch(`https://itghar-back.onrender.com/single-user?email=${user?.email}`, {
      method: "GET",
      headers: {
        authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }).then((res) => {
      if (res.status === 401 || res.status === 403) {
        navigate("/");
        signOut(auth);
      }

      return res.json();
    })
  );

  if (isLoading || PLoading) {
    return <Loading />;
  }

  console.log(data);

  return (
    <Fragment>
      <section className="border-b border-[#f2f2f2] sticky top-0 bg-base-100 z-50 ">
        <DashboardNav profile={data} />
      </section>
      <section className="dashboard_container font-roboto max-w-[1200px] mx-auto ">
        <DashboardSideBar profile={data} />
        <div>
          <Outlet />
        </div>
      </section>
    </Fragment>
  );
};

export default Dashboard;
